import { Link, useNavigate } from "react-router";
import {
    Button,
    Card,
    CardBody,
    CardLink,
    CardText,
    CardTitle,
    Col,
    Container,
    Row,
} from "reactstrap";
import useAuth from "../hooks/useAuth";

export default function Home() {
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();

    if (auth.viewLevel === "adminreports") {
        navigate('/');
    }

    return (
        <Container>
            <Card>
                <CardBody>
                    <Row>
                        <Col className="col-2 flex-fill">
                        </Col>
                        <Col className="col-4">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">
                                        My Detailed Completions Report
                                    </CardTitle>
                                    <CardText>
                                        Completed courses and training hours.
                                    </CardText>
                                    <Link
                                        to="/myreports/detailedcompletions/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">My Training Plan Progress Report</CardTitle>
                                    <CardText>Progress details on assigned Training Plans.</CardText>
                                    <Link
                                        to="/myreports/learningplan/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-2 flex-fill">
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    );
}
